import { SETTINGS as pickTickets } from "views/Configuration/settings/fulfillment/pickTickets";
import { SETTINGS as shipments } from "views/Configuration/settings/fulfillment/shipments";

export const SETTINGS = {
  shipments,
  pickTickets,
};
